import { Hash } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";

export const HashtagCloud = () => {
  const { data: hashtags } = useQuery({
    queryKey: ['trending-hashtags'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('hashtags')
        .select('*')
        .order('usage_count', { ascending: false })
        .limit(15);

      if (error) throw error;
      return data;
    },
  });

  const getHashtagSize = (usageCount: number, maxUsage: number) => {
    const ratio = usageCount / maxUsage;
    if (ratio > 0.8) return "text-lg";
    if (ratio > 0.5) return "text-base";
    return "text-sm";
  };

  const maxUsage = Math.max(...(hashtags?.map(h => h.usage_count) || [1]));

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Hash className="w-5 h-5 text-primary" />
        <h3 className="text-lg font-semibold">Trending Hashtags</h3>
      </div>

      <div className="flex flex-wrap gap-2">
        {hashtags?.map((hashtag) => (
          <Link key={hashtag.id} to={`/hashtags/${hashtag.name}`}>
            <Badge 
              variant="secondary" 
              className={`hover:bg-primary hover:text-primary-foreground transition-colors cursor-pointer ${getHashtagSize(hashtag.usage_count, maxUsage)}`}
            >
              #{hashtag.name} {hashtag.usage_count > 1 && `(${hashtag.usage_count})`}
            </Badge>
          </Link>
        ))}
      </div>
    </div>
  );
};